import { memo } from 'react';

import { Loading } from '@/components/core';
import {
  APITriggerNodeContent,
  EmailTriggerNodeContent,
  EmptyTriggerNodeContent,
  PowerAutomateTriggerNodeContent,
  ZapierTriggerNodeContent,
} from '@/components/flow';
import {
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { useGetAgentFromPath } from '@/hooks';
import { toActionId, useGetAction } from '@/hooks/api';

export type TriggerNodeProps = {
  actionId?: string;
  hookId?: string;
};

const ITriggerNode = ({ actionId }: TriggerNodeProps) => {
  const { data: agent, isPending: isPendingAgent } = useGetAgentFromPath();
  const { data: action } = useGetAction(toActionId(actionId));

  if (isPendingAgent) return <Loading label="Loading ..." />;
  if (!agent) return null;

  return (
    <div className="w-full">
      {action?.functionId === CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID ? (
        <EmailTriggerNodeContent agentId={agent.agentId} actionId={action?.actionId} />
      ) : action?.functionId === CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID ? (
        <PowerAutomateTriggerNodeContent agentId={agent.agentId} actionId={action?.actionId} />
      ) : action?.functionId === CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID ? (
        <ZapierTriggerNodeContent agentId={agent.agentId} actionId={action?.actionId} />
      ) : action?.functionId === CREATE_AGENT_RUN_FROM_API_FUNCTION_ID ? (
        <APITriggerNodeContent agentId={agent.agentId} actionId={action?.actionId} />
      ) : (
        <EmptyTriggerNodeContent agentId={agent.agentId} />
      )}
    </div>
  );
};

export const TriggerNode = memo(ITriggerNode) as typeof ITriggerNode;
